(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fitment-scanner"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeScanner(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const lifecycle = new AbortController();
    function listen(target, type, handler, options = {}) {
      target.addEventListener(type, handler, {...(typeof options === 'boolean' ? {capture: options} : options), signal: lifecycle.signal});
    }
    const dialog = root.querySelector('dialog');
    const opener = root.querySelector('[data-face-fit-open]');
    const video = root.querySelector('[data-video]');
    const progress = root.querySelector('[data-progress]');
    const scanStatus = root.querySelector('[data-scan-status]');
    const scanHeading = root.querySelector('[data-scan-heading]');
    const stageSteps = Array.from(root.querySelectorAll('[data-stage-step]'));
    const resultHeading = root.querySelector('[data-result-heading]');
    const resultStatus = root.querySelector('[data-result-status]');
    const manualOnly = root.querySelector('[data-manual-only]');
    const recommended = root.querySelector('[data-recommended]');
    const measurement = root.querySelector('[data-measurement]');
    const applyButton = root.querySelector('[data-apply]');
    const addButton = root.querySelector('[data-add]');
    const errorMessage = root.querySelector('[data-error-message]');
    const guideVideos = Array.from(root.querySelectorAll('[data-guide-video]'));
    const guidePanels = Array.from(root.querySelectorAll('[data-guide-panel]'));
    const guideDots = Array.from(root.querySelectorAll('[data-guide-dot]'));
    const guide = root.querySelector('[data-guide]');
    const guidePrevious = root.querySelector('[data-guide-prev]');
    const guideForward = root.querySelector('[data-guide-forward]');
    const guideNext = root.querySelector('[data-guide-next]');
    const guideSkip = root.querySelector('[data-guide-skip]');
    const startButton = root.querySelector('[data-start]');
    const resultMotion = root.querySelector('[data-result-motion]');
    const targetSamples = 60;
    const frameIntervalMs = 0;
    const referenceIrisDiameterCm = 1.17;
    const maskCurveFactor = 1.28;
    const warmupTarget = 30;
    const measurementStorageKey = 'sa_face_fit_measurement_v1';
    const measurementSourceStorageKey = 'sa_face_fit_product_v1';
    const measurementDeviceStorageKey = 'sa_face_fit_device_v1';
    const measurementStatsStorageKey = 'sa_face_fit_stats_v1';
    const attemptSessionKey = 'sa_face_fit_attempts_v1:' + (root.dataset.productId || root.dataset.productHandle);
    const attemptSessions = window.SpaceArmoryFitAttemptSessions ||= new Map();
    let scanAttempts = {schema:1, attempts:0, retries:0, failed:0};
    let attemptRunning = false;
    const legacyMeasurementStorageKey = '_sa_sinsi_olcum';
    const legacySourceStorageKey = '_sa_sinsi_kaynak';
    const measurementPropertyName = '_Face Fit Measurement';
    const scanSourcePropertyName = '_Face Fit Source';
    const scanActionPropertyName = '_Face Fit Action';
    const scanDevicePropertyName = '_Face Fit Device';
    const measuredPropertyName = 'Measured Size';
    const engineVersion = 'face-fit-engine/1.0.0';
    const sizeRuleVersion = 'size-rules/1.0.0';
    const modelVersion = 'model/64184e229b26';
    const dataSchemaVersion = 'schema/1';
    const sourceVersion = [engineVersion, sizeRuleVersion, modelVersion, dataSchemaVersion].join(' | ');
    let stream = null;
    let worker = null;
    let mainThreadLandmarker = null;
    let inferenceMode = 'worker';
    let engineGeneration = 0;
    let enginePromise = null;
    let cancelEnginePreparation = null;
    let mainThreadWarmupFrames = 0;
    let mainThreadFrameCounter = 0;
    let mainThreadIsDark = false;
    let lightCanvas = null;
    let lightContext = null;
    let frameCallback = 0;
    let framePending = false;
    let lastFrameAt = 0;
    let samples = [];
    let generation = 0;
    let sessionStarting = false;
    let finalizing = false;
    let scanTimeout = 0;
    let workerReadyTimer = 0;
    let cancelWorkerInit = null;
    let cancelVideoMetadataWait = null;
    let activeSize = null;
    let activeVariantId = null;
    let activeMeasurementText = '';
    let activeMeasurementDevice = null;
    let activeMeasurementStats = null;
    let variantActionBusy = false;
    let previousBodyOverflow = '';
    let bodyScrollLocked = false;
    let focusAfterClose = true;
    let guideStep = 0;
    let guideActionAt = -Infinity;
    let guidePointer = null;
    let guideTransitions = [];
    let successHapticPlayed = false;
    let handoffUrl = '';
    let handoffModules = null;
    const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const allowMotionVideo = !reducedMotion && !saveData;

    function hydrateMotionPoster(videoElement) {
      if (!videoElement) return;
      if (!videoElement.poster && videoElement.dataset.poster) videoElement.poster = videoElement.dataset.poster;
    }

    function hydrateMotion(videoElement) {
      if (!videoElement) return;
      hydrateMotionPoster(videoElement);
      if (!allowMotionVideo || videoElement.dataset.hydrated === 'true') return;
      const source = videoElement.querySelector('source[data-src]');
      if (!source) return;
      videoElement.preload = 'auto';
      source.src = source.dataset.src;
      videoElement.dataset.hydrated = 'true';
      videoElement.load();
    }

    function prepareNextGuideVideo(index) {
      // Wait until the visible animation plays before spending bandwidth on the next one.
      if (!allowMotionVideo || !dialog.open || root.dataset.activeScreen !== 'intro' || index !== guideStep) return;
      if (guideVideos[index].paused) return;
      hydrateMotion(guideVideos[index + 1]);
    }

    function pauseGuideVideos() {
      cancelGuideTransition();
      guideVideos.forEach((item) => item.pause());
    }

    function cancelGuideTransition() {
      guideTransitions.forEach((animation) => { animation.onfinish = null; animation.cancel(); });
      guideTransitions = [];
      guideVideos.forEach((item, index) => { item.hidden = index !== guideStep; });
      guidePanels.forEach((item, index) => { item.hidden = index !== guideStep; });
    }

    function animateGuideChange(previousStep, direction) {
      // Both slides share the same fixed stage and text row: movement never changes layout.
      for (const items of [guideVideos, guidePanels]) {
        const outgoing = items[previousStep];
        const incoming = items[guideStep];
        if (!outgoing || !incoming || typeof incoming.animate !== 'function') continue;
        outgoing.hidden = false;
        const out = outgoing.animate([
          {opacity: 1, transform: 'translateX(0)'},
          {opacity: 0, transform: 'translateX(' + (-10 * direction) + 'px)'}
        ], {duration: 220, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'});
        const enter = incoming.animate([
          {opacity: 0, transform: 'translateX(' + (14 * direction) + 'px)'},
          {opacity: 1, transform: 'translateX(0)'}
        ], {duration: 320, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'});
        out.onfinish = () => { outgoing.hidden = true; out.cancel(); };
        enter.onfinish = () => { enter.cancel(); };
        guideTransitions.push(out, enter);
      }
    }

    function setGuideStep(nextStep, animate = true) {
      if (!guidePanels.length) return;
      const previousStep = guideStep;
      cancelGuideTransition();
      guideStep = Math.max(0, Math.min(Number(nextStep) || 0, guidePanels.length - 1));
      guidePanels.forEach((panel, index) => {
        panel.hidden = index !== guideStep;
        panel.setAttribute('aria-hidden', String(index !== guideStep));
      });
      guideDots.forEach((dot, index) => {
        if (index === guideStep) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });
      guideVideos.forEach((item, index) => {
        item.hidden = index !== guideStep;
        item.pause();
        if (index !== guideStep) return;
        hydrateMotion(item);
        if (allowMotionVideo) {
          try { item.currentTime = 0; } catch (error) {}
          const playPromise = item.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
        }
      });
      // The upcoming still can be ready even if video playback is disabled or delayed.
      hydrateMotionPoster(guideVideos[guideStep + 1]);
      if (animate && !reducedMotion && previousStep !== guideStep && dialog.open) {
        animateGuideChange(previousStep, guideStep > previousStep ? 1 : -1);
      }
      const finalStep = guideStep === guidePanels.length - 1;
      if (guidePrevious) guidePrevious.disabled = guideStep === 0;
      if (guideForward) guideForward.disabled = finalStep;
      if (guideNext) guideNext.hidden = finalStep;
      if (startButton) startButton.hidden = !finalStep;
      if (guideSkip) guideSkip.hidden = finalStep;
    }

    // One deliberate action per transition, including the final camera button.
    function acceptGuideAction() {
      const now = performance.now();
      if (now - guideActionAt < 360) return false;
      guideActionAt = now;
      return true;
    }

    function resetResultMotion() {
      if (!resultMotion) return;
      resultMotion.pause();
      resultMotion.hidden = true;
      try { resultMotion.currentTime = 0; } catch (error) {}
    }

    function playResultMotion() {
      if (!resultMotion) return;
      resultMotion.hidden = false;
      resultMotion.loop = true;
      hydrateMotion(resultMotion);
      if (!allowMotionVideo) return;
      try { resultMotion.currentTime = 0; } catch (error) {}
      const playPromise = resultMotion.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
    }

    function triggerSuccessHaptic() {
      if (successHapticPlayed || reducedMotion) return;
      successHapticPlayed = true;
      if (typeof navigator.vibrate !== 'function') return;
      try { navigator.vibrate([35, 45, 70]); } catch (error) {}
    }

    function privacyAnalytics(name) {
      try {
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'face_fit_' + name });
      } catch (error) {}
    }

    function announceStatus(code) {
      const value = root.dataset['status' + code.charAt(0).toUpperCase() + code.slice(1)];
      if (value) scanStatus.textContent = value;
    }

    function decodeText(value) {
      const parser = document.createElement('textarea');
      parser.innerHTML = String(value || '');
      return parser.value;
    }

    function errorText(code) {
      const key = code === 'permission' ? 'errorPermission' : code === 'camera' ? 'errorCamera' : code === 'busy' ? 'errorBusy' : code === 'timeout' ? 'errorTimeout' : code === 'background' ? 'errorBackground' : 'errorModel';
      return root.dataset[key] || root.dataset.errorModel;
    }

    function setStage(name) {
      root.dataset.activeStage = name;
      const order = ['camera', 'align', 'measure', 'result'];
      const activeIndex = order.indexOf(name);
      stageSteps.forEach((step) => {
        const index = order.indexOf(step.dataset.stageStep);
        step.classList.toggle('is-complete', index >= 0 && index < activeIndex);
        if (index === activeIndex) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      if (!scanHeading) return;
      const title = name === 'camera' ? root.dataset.stageCameraTitle : name === 'measure' ? root.dataset.stageMeasureTitle : root.dataset.stageAlignTitle;
      if (title) scanHeading.textContent = title;
    }

    function setScreen(name, focusSelector) {
      root.dataset.activeScreen = name;
      root.querySelectorAll('[data-screen]').forEach((screen) => {
        screen.hidden = screen.dataset.screen !== name;
      });
      const focusTarget = focusSelector ? root.querySelector(focusSelector) : root.querySelector('[data-screen="' + name + '"] .face-fit__heading');
      if (focusTarget) requestAnimationFrame(() => focusTarget.focus({preventScroll: true}));
    }

    function storeAttempts() {
      attemptSessions.set(attemptSessionKey, {...scanAttempts});
      try { sessionStorage.setItem(attemptSessionKey, JSON.stringify(scanAttempts)); } catch {}
    }

    function startAttempt() {
      let previous = attemptSessions.get(attemptSessionKey);
      if (!previous) try { previous = JSON.parse(sessionStorage.getItem(attemptSessionKey)); } catch {}
      if (previous?.schema === 1 && Number.isSafeInteger(previous.attempts) && previous.attempts >= 0 &&
        Number.isSafeInteger(previous.failed) && previous.failed >= 0 && previous.failed <= previous.attempts) {
        scanAttempts = {schema:1, attempts:previous.attempts, retries:Math.max(0,previous.attempts-1), failed:previous.failed};
      }
      scanAttempts.attempts += 1;
      scanAttempts.retries = scanAttempts.attempts - 1;
      attemptRunning = true;
      storeAttempts();
    }

    function failAttempt() {
      if (!attemptRunning) return;
      attemptRunning = false;
      scanAttempts.failed += 1;
      storeAttempts();
    }

    function completeAttempt() {
      if (!attemptRunning) return null;
      attemptRunning = false;
      return window.SpaceArmoryFitRules?.normalizeScanStats?.({...scanAttempts});
    }

    function stopMedia({preserveEngine = false} = {}) {
      // Closing/cancelling is not a failed scan. Terminal errors call failAttempt first.
      attemptRunning = false;
      generation += 1;
      guidePointer = null;
      pauseGuideVideos();
      root.classList.remove('face-fit--camera-ready');
      if (scanTimeout) window.clearTimeout(scanTimeout);
      scanTimeout = 0;
      if (cancelVideoMetadataWait) { const cancel = cancelVideoMetadataWait; cancelVideoMetadataWait = null; cancel(new Error('cancelled')); }
      if (frameCallback && video && typeof video.cancelVideoFrameCallback === 'function') video.cancelVideoFrameCallback(frameCallback);
      if (frameCallback && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(frameCallback);
      frameCallback = 0;
      framePending = false;
      if (video) {
        video.pause();
        video.srcObject = null;
      }
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        stream = null;
      }
      if (!preserveEngine) disposeInferenceEngine();
      mainThreadWarmupFrames = 0;
      mainThreadFrameCounter = 0;
      mainThreadIsDark = false;
      samples = [];
      if (progress) progress.value = 0;
      sessionStarting = false;
    }

    function finishDialogClose() {
      if (dialog.open || !bodyScrollLocked) return;
      bodyScrollLocked = false;
      stopMedia();
      document.body.style.overflow = previousBodyOverflow;
      root.dispatchEvent(new CustomEvent('space-armory:scanner-visibility', {bubbles: true}));
      if (focusAfterClose && opener && opener.isConnected) opener.focus();
    }

    function returnFocus({focus = true} = {}) {
      if (!dialog.open) return;
      focusAfterClose = focus;
      dialog.close();
      // The native close event is queued. Release our lock before the drawer
      // captures it, and prevent the late event from changing the drawer's lock.
      finishDialogClose();
    }

    function disposeInferenceEngine() {
      engineGeneration += 1;
      enginePromise = null;
      if (cancelEnginePreparation) cancelEnginePreparation();
      cancelEnginePreparation = null;
      if (cancelWorkerInit) cancelWorkerInit();
      cancelWorkerInit = null;
      if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
      workerReadyTimer = 0;
      if (worker) worker.terminate();
      worker = null;
      if (mainThreadLandmarker) {
        try { mainThreadLandmarker.close(); } catch (error) {}
      }
      mainThreadLandmarker = null;
      inferenceMode = 'worker';
    }

    function prepareInferenceEngine() {
      if (enginePromise) return enginePromise;
      const token = engineGeneration;
      let timer;
      const cancelled = new Promise((resolve, reject) => {
        cancelEnginePreparation = () => reject(new Error('cancelled'));
        timer = window.setTimeout(() => reject(new Error('model_timeout')), 45000);
      });
      enginePromise = Promise.race([createInferenceEngine(token), cancelled]).then((engine) => {
        if (token !== engineGeneration || !dialog.open) throw new Error('cancelled');
        return engine;
      }).catch((error) => {
        if (token === engineGeneration) disposeInferenceEngine();
        throw error;
      }).finally(() => {
        window.clearTimeout(timer);
        if (token === engineGeneration) cancelEnginePreparation = null;
      });
      return enginePromise;
    }

    function openDialog() {
      guideActionAt = -Infinity;
      if (dialog.open) return;
      focusAfterClose = true;
      previousBodyOverflow = document.body.style.overflow;
      bodyScrollLocked = true;
      document.body.style.overflow = 'hidden';
      setScreen('intro', '[data-close]');
      dialog.showModal();
      const preparingGeneration = engineGeneration;
      requestAnimationFrame(() => {
        window.setTimeout(() => {
          if (dialog.open && preparingGeneration === engineGeneration) void prepareInferenceEngine().catch(() => {});
        }, 0);
      });
      root.dispatchEvent(new CustomEvent('space-armory:sizing-guide-opened', {bubbles: true, detail: {guide: 'camera'}}));
      root.dispatchEvent(new CustomEvent('space-armory:scanner-visibility', {bubbles: true}));
      setGuideStep(0, false);
      privacyAnalytics('open');
    }

    async function showPhoneHandoff() {
      stopMedia();
      resetResultMotion();
      const token = generation;
      const qrImage = root.querySelector('[data-qr-image]');
      const qrStatus = root.querySelector('[data-qr-status]');
      const frame = root.querySelector('[data-qr-frame]');
      const link = root.querySelector('[data-handoff-link]');
      const copyButton = root.querySelector('[data-copy-handoff]');
      handoffUrl = '';
      qrImage.hidden = true;
      qrStatus.hidden = false;
      qrStatus.textContent = 'Preparing your QR code…';
      frame.setAttribute('aria-busy', 'true');
      copyButton.disabled = true;
      link.hidden = true;
      root.querySelector('[data-copy-status]').textContent = '';
      setScreen('handoff');
      try {
        if (!handoffModules) handoffModules = Promise.all([
          import(root.dataset.handoffModuleUrl), import(root.dataset.qrModuleUrl)
        ]).catch((error) => { handoffModules = null; throw error; });
        const [handoff, qr] = await handoffModules;
        if (token !== generation || !dialog.open || root.dataset.activeScreen !== 'handoff') return;
        const form = productForm();
        const variant = form && form.querySelector('[name="id"]');
        const theme = (window.Shopify && window.Shopify.theme) || {};
        handoffUrl = handoff.buildPhoneUrl({
          currentUrl: window.location.href,
          productUrl: root.dataset.productUrl,
          productHandle: root.dataset.productHandle,
          themeId: theme.id || root.dataset.themeId,
          themeRole: theme.role || root.dataset.themeRole,
          variantId: variant && !variant.disabled ? variant.value : ''
        });
        link.href = handoffUrl;
        copyButton.disabled = false;
        qrImage.src = handoff.qrImageData(qr.default, handoffUrl);
        qrImage.hidden = false;
        qrStatus.hidden = true;
        privacyAnalytics('phone_handoff');
      } catch (error) {
        if (token !== generation || !dialog.open) return;
        qrStatus.textContent = 'The QR code could not load. Close this window and try again.';
        if (handoffUrl) {
          link.href = handoffUrl;
          link.hidden = false;
          copyButton.disabled = false;
        }
      } finally {
        if (token === generation) frame.setAttribute('aria-busy', 'false');
      }
    }

    async function copyPhoneLink() {
      if (!handoffUrl) return;
      const status = root.querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(handoffUrl);
        status.textContent = 'Link copied. Open it on your phone.';
      } catch (error) {
        const link = root.querySelector('[data-handoff-link]');
        link.href = handoffUrl;
        link.hidden = false;
        status.textContent = 'Use the link below to copy or share it to your phone.';
      }
    }

    function showPhoneReady() {
      stopMedia();
      setScreen('phone-ready');
    }

    function showError(code) {
      failAttempt();
      stopMedia();
      const titles = {permission: 'Camera access needed', camera: 'Camera unavailable', busy: 'Camera is busy', timeout: 'Measurement timed out', background: 'Measurement interrupted', quality: 'Try measuring again'};
      root.querySelector('[data-error-heading]').textContent = titles[code] || 'Unable to start measurement';
      errorMessage.textContent = code === 'quality'
        ? 'We couldn’t get a reliable measurement. Face the camera in even light, keep still, and try again.'
        : errorText(code);
      setScreen('error', '[data-error-heading]');
    }

    function createWorker(token) {
      const instance = new Worker(root.dataset.workerUrl);
      worker = instance;
      return new Promise((resolve, reject) => {
        let workerReady = false;
        workerReadyTimer = window.setTimeout(() => { workerReadyTimer = 0; cancelWorkerInit = null; reject(new Error('worker_timeout')); }, 30000);
        cancelWorkerInit = () => { if (workerReadyTimer) window.clearTimeout(workerReadyTimer); workerReadyTimer = 0; reject(new Error('cancelled')); };
        instance.onmessage = (event) => {
          if (token !== engineGeneration || worker !== instance) return;
          const data = event.data || {};
          if (data.type === 'ready') {
            if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
            workerReadyTimer = 0;
            cancelWorkerInit = null;
            workerReady = true;
            resolve(instance);
          } else if (data.type === 'init-error') {
            if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
            workerReadyTimer = 0;
            cancelWorkerInit = null;
            if (data.error) console.error('[Face Fit] MediaPipe initialization failed:', data.error.name, data.error.message);
            reject(new Error('worker_init'));
          } else if (data.type === 'result') {
            if (data.generation === generation && stream && dialog.open) onWorkerResult(data);
          } else if (data.type === 'detect-error' && data.generation === generation && stream) {
            framePending = false;
            scanStatus.textContent = root.dataset.statusHold;
          }
        };
        instance.onerror = () => {
          if (token !== engineGeneration || worker !== instance) return;
          if (!workerReady) {
            if (workerReadyTimer) window.clearTimeout(workerReadyTimer);
            workerReadyTimer = 0;
            cancelWorkerInit = null;
            reject(new Error('worker_error'));
          } else if (dialog.open) {
            showError('model');
          }
        };
        instance.postMessage({ type: 'init' });
      });
    }

    function shouldUseMainThreadInference() {
      const userAgent = navigator.userAgent || '';
      const isiOS = /iPhone|iPad|iPod/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      const isSafari = /Safari/i.test(userAgent) && !/Chrome|CriOS|Chromium|Edg|OPR|FxiOS/i.test(userAgent);
      return isiOS || isSafari;
    }

    async function createMainThreadLandmarker(token) {
      const vision = await import(root.dataset.visionModuleUrl);
      const moduleUrl = new URL(root.dataset.visionModuleUrl, window.location.href);
      const assetRoot = new URL('./', moduleUrl).href.replace(/\/$/, '');
      const files = await vision.FilesetResolver.forVisionTasks(assetRoot);
      if (token !== engineGeneration || !dialog.open) throw new Error('cancelled');
      const landmarker = await vision.FaceLandmarker.createFromOptions(files, {
        baseOptions: { modelAssetPath: root.dataset.modelUrl },
        runningMode: 'VIDEO',
        numFaces: 1,
        minFaceDetectionConfidence: 0.5,
        minFacePresenceConfidence: 0.5,
        minTrackingConfidence: 0.5,
        outputFaceBlendshapes: false,
        outputFacialTransformationMatrixes: false
      });
      if (token !== engineGeneration || !dialog.open) {
        landmarker.close();
        throw new Error('cancelled');
      }
      mainThreadLandmarker = landmarker;
      inferenceMode = 'main';
      return landmarker;
    }

    async function createInferenceEngine(token) {
      if (!shouldUseMainThreadInference()) {
        try {
          const readyWorker = await createWorker(token);
          inferenceMode = 'worker';
          return readyWorker;
        } catch (error) {
          if (token !== engineGeneration || !dialog.open) throw new Error('cancelled');
          if (worker) worker.terminate();
          worker = null;
          console.warn('[Face Fit] Worker unavailable; using the browser-compatible fallback.');
        }
      }
      return createMainThreadLandmarker(token);
    }

    function distance3d(a, b, width, height) {
      const dx = (a.x - b.x) * width;
      const dy = (a.y - b.y) * height;
      const dz = (a.z - b.z) * width;
      return Math.sqrt(dx * dx + dy * dy + dz * dz);
    }

    function eyeAspectRatio(points, width, height) {
      const vertical1 = distance3d(points[1], points[5], width, height);
      const vertical2 = distance3d(points[2], points[4], width, height);
      const horizontal = distance3d(points[0], points[3], width, height);
      return (vertical1 + vertical2) / (2 * horizontal);
    }

    function sampleMainThreadLight() {
      mainThreadFrameCounter += 1;
      if (mainThreadFrameCounter % 15 !== 0) return mainThreadIsDark;
      if (!lightCanvas) {
        lightCanvas = document.createElement('canvas');
        lightCanvas.width = 32;
        lightCanvas.height = 24;
        lightContext = lightCanvas.getContext('2d', { willReadFrequently: true });
      }
      if (!lightContext) return false;
      lightContext.drawImage(video, 0, 0, 32, 24);
      const pixels = lightContext.getImageData(0, 0, 32, 24).data;
      let luminance = 0;
      for (let index = 0; index < pixels.length; index += 4) {
        luminance += 0.299 * pixels[index] + 0.587 * pixels[index + 1] + 0.114 * pixels[index + 2];
      }
      mainThreadIsDark = luminance / (pixels.length / 4) < 30;
      return mainThreadIsDark;
    }

    function analyzeMainThreadFrame(now) {
      if (sampleMainThreadLight()) return { status: 'dark' };
      const result = mainThreadLandmarker.detectForVideo(video, now);
      const faces = result.faceLandmarks || [];
      if (faces.length !== 1) return { status: faces.length > 1 ? 'multiple' : 'face' };

      mainThreadWarmupFrames += 1;
      if (mainThreadWarmupFrames < warmupTarget) return { status: 'warming' };

      const points = faces[0];
      const nose = points[1];
      const leftCheek = points[234];
      const rightCheek = points[454];
      const top = points[10];
      const chin = points[152];
      const leftIrisEdge = points[469];
      const rightIrisEdge = points[471];
      const earPoint = points[127];
      const required = [nose, leftCheek, rightCheek, top, chin, leftIrisEdge, rightIrisEdge, earPoint];
      if (required.some((point) => !point)) return { status: 'face' };
      if (leftCheek.x < 0.05 || rightCheek.x > 0.95 || top.y < 0.05 || chin.y > 0.95) return { status: 'partial' };

      const faceWidthRatio = rightCheek.x - leftCheek.x;
      if (faceWidthRatio < 0.26) return { status: 'far' };
      if (faceWidthRatio > 0.36) return { status: 'close' };

      const centerX = (leftCheek.x + rightCheek.x) / 2;
      const centerY = (top.y + chin.y) / 2;
      if (centerX < 0.4 || centerX > 0.6 || centerY < 0.35 || centerY > 0.65) return { status: 'center' };

      const horizontalSymmetry = Math.abs(nose.x - leftCheek.x) / Math.max(Math.abs(rightCheek.x - nose.x), 0.001);
      const verticalSymmetry = Math.abs(nose.y - top.y) / Math.max(Math.abs(chin.y - nose.y), 0.001);
      if (horizontalSymmetry < 0.7 || horizontalSymmetry > 1.4 || verticalSymmetry < 0.7 || verticalSymmetry > 1.45) return { status: 'turn' };

      const leftEye = [points[33], points[160], points[158], points[133], points[153], points[144]];
      const rightEye = [points[362], points[385], points[387], points[263], points[373], points[380]];
      if (leftEye.some((point) => !point) || rightEye.some((point) => !point)) return { status: 'face' };
      if (eyeAspectRatio(leftEye, video.videoWidth, video.videoHeight) < 0.2 || eyeAspectRatio(rightEye, video.videoWidth, video.videoHeight) < 0.2) return { status: 'eyes' };

      const irisDistance = distance3d(leftIrisEdge, rightIrisEdge, video.videoWidth, video.videoHeight);
      if (irisDistance < 0.1 || !Number.isFinite(irisDistance)) return { status: 'focus' };

      const measuredCm = distance3d(nose, earPoint, video.videoWidth, video.videoHeight)
        * (referenceIrisDiameterCm / irisDistance)
        * maskCurveFactor;
      if (!Number.isFinite(measuredCm) || measuredCm <= 5 || measuredCm >= 40) return { status: 'focus' };
      return { status: 'aligned', value: measuredCm };
    }

    function launchFrameLoop(token) {
      const schedule = () => {
        if (token !== generation || !stream || !dialog.open) return;
        if (typeof video.requestVideoFrameCallback === 'function') {
          frameCallback = video.requestVideoFrameCallback((now) => {
            processFrame(now, token);
            schedule();
          });
        } else {
          frameCallback = requestAnimationFrame((now) => {
            processFrame(now, token);
            schedule();
          });
        }
      };
      schedule();
    }

    async function revealStablePreview(token, previewStartedAt) {
      const minimumWait = Math.max(0, 1000 - (performance.now() - previewStartedAt));
      const delay = new Promise((resolve) => window.setTimeout(resolve, minimumWait));
      const frames = new Promise((resolve) => {
        let count = 0;
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          resolve();
        };
        const fallback = window.setTimeout(finish, 900);
        const next = () => {
          if (done) return;
          if (token !== generation || !stream || !dialog.open) {
            window.clearTimeout(fallback);
            finish();
            return;
          }
          count += 1;
          if (count >= 1) {
            window.clearTimeout(fallback);
            finish();
            return;
          }
          if (typeof video.requestVideoFrameCallback === 'function') video.requestVideoFrameCallback(next);
          else requestAnimationFrame(next);
        };
        if (typeof video.requestVideoFrameCallback === 'function') video.requestVideoFrameCallback(next);
        else requestAnimationFrame(next);
      });
      await Promise.all([delay, frames]);
      if (token === generation && stream && dialog.open) root.classList.add('face-fit--camera-ready');
    }

    async function processFrame(now, token) {
      if (token !== generation || framePending || (!worker && !mainThreadLandmarker) || !video.videoWidth) return;
      if (now - lastFrameAt < frameIntervalMs) return;
      lastFrameAt = now;
      framePending = true;
      if (inferenceMode === 'main') {
        try {
          const data = analyzeMainThreadFrame(now);
          if (token === generation && dialog.open) onWorkerResult(data);
          else framePending = false;
        } catch (error) {
          framePending = false;
          scanStatus.textContent = root.dataset.statusHold;
          console.error('[Face Fit] Browser fallback frame failed:', error);
        }
        return;
      }
      try {
        const bitmap = await createImageBitmap(video);
        if (token !== generation || !worker) {
          bitmap.close();
          framePending = false;
          return;
        }
        worker.postMessage({ type: 'frame', bitmap, timestamp: now, generation: token }, [bitmap]);
      } catch (error) {
        framePending = false;
      }
    }

    function onWorkerResult(data) {
      framePending = false;
      if (data.status !== 'aligned') {
        setStage('align');
        const statusMap = { warming: 'warming', multiple: 'multiple', face: 'face', partial: 'partial', far: 'far', close: 'close', center: 'center', turn: 'turn', eyes: 'eyes', focus: 'focus', dark: 'dark' };
        announceStatus(statusMap[data.status] || 'face');
        return;
      }
      setStage('measure');
      announceStatus('measuring');
      samples.push(data.value);
      progress.value = Math.min(samples.length, targetSamples);
      const percent = Math.round((samples.length / targetSamples) * 100);
      scanStatus.textContent = root.dataset.progressTemplate.replace('__PERCENT__', String(percent));
      if (samples.length >= targetSamples) finishScan();
    }

    function median(values) {
      const sorted = values.slice().sort((a, b) => a - b);
      const middle = Math.floor(sorted.length / 2);
      return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
    }

    function classify(values) {
      if (values.length < targetSamples) return { reason: 'samples' };
      const center = window.SpaceArmoryFitRules?.stable(values);
      return {size: window.SpaceArmoryFitRules?.sizeFor(center), metric: center};
    }

    function productSection() {
      const id = root.dataset.sectionId;
      return id ? document.getElementById('shopify-section-' + id) : root.closest('section');
    }

    function productInfo() {
      const section = productSection();
      if (!section) return null;
      return section.querySelector('product-info') || section;
    }

    function productForm() {
      const scope = productInfo();
      return scope && (
        scope.querySelector('product-form form[action*="/cart/add"]') ||
        scope.querySelector('form[data-type="add-to-cart-form"]')
      );
    }

    function storedMeasurement() {
      try {
        return sessionStorage.getItem(measurementStorageKey) || sessionStorage.getItem(legacyMeasurementStorageKey) || '';
      } catch (error) {
        return '';
      }
    }

    function storedMeasurementSource() {
      try {
        return sessionStorage.getItem(measurementSourceStorageKey) || sessionStorage.getItem(legacySourceStorageKey) || '';
      } catch (error) {
        return '';
      }
    }

    function setLineItemProperty(form, name, value) {
      if (!form || !value) return;
      let input = Array.from(form.querySelectorAll('input[name^="properties["]')).find((item) => item.name === 'properties[' + name + ']');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        form.appendChild(input);
      }
      input.value = value;
    }

    function removeLineItemProperty(name) {
      document.querySelectorAll('input[name^="properties["]').forEach((input) => {
        if (input.name === 'properties[' + name + ']') input.remove();
      });
    }

    function clearStoredMeasurement() {
      try {
        [measurementStorageKey, measurementSourceStorageKey, measurementDeviceStorageKey, measurementStatsStorageKey, legacyMeasurementStorageKey, legacySourceStorageKey].forEach((key) => sessionStorage.removeItem(key));
      } catch (error) {}
    }

    function attachMeasurementStats(form, stats) {
      if (!form) return;
      (window.SpaceArmoryFitRules?.scanStatsKeys || []).forEach(name => {
        form.querySelector('input[name="properties[' + name + ']"]')?.remove();
      });
      Object.entries(window.SpaceArmoryFitRules?.scanStatsProperties?.(stats) || {}).forEach(([name,value]) => setLineItemProperty(form,name,value));
    }

    function attachPendingMeasurement(form) {
      const value = storedMeasurement();
      const source = storedMeasurementSource();
      const product = root.dataset.productHandle || root.dataset.productId || '';
      if (!form || !value) return;
      if (!source || source !== product) {
        clearStoredMeasurement();
        const measurementInput = form.querySelector('input[name="properties[' + measurementPropertyName + ']"]');
        if (measurementInput) measurementInput.remove();
        const sourceInput = form.querySelector('input[name="properties[' + scanSourcePropertyName + ']"]');
        if (sourceInput && sourceInput.value.startsWith('auto_result |')) {
          sourceInput.remove();
          form.querySelector('input[name="properties[' + scanDevicePropertyName + ']"]')?.remove();
          form.querySelector('input[name="properties[' + scanActionPropertyName + ']"]')?.remove();
          attachMeasurementStats(form, null);
        }
        return;
      }
      if (form.querySelector('input[name="properties[' + measuredPropertyName + ']"]')) return;
      setLineItemProperty(form, measurementPropertyName, value);
      setLineItemProperty(form, scanSourcePropertyName, 'auto_result | ' + source + ' | ' + sourceVersion);
      form.querySelector('input[name="properties[' + scanDevicePropertyName + ']"]')?.remove();
      try {
        const device = JSON.parse(sessionStorage.getItem(measurementDeviceStorageKey));
        setLineItemProperty(form, scanDevicePropertyName, window.SpaceArmoryFitDevice?.text(device));
      } catch {}
      let stats;
      try { stats = JSON.parse(sessionStorage.getItem(measurementStatsStorageKey)); } catch {}
      attachMeasurementStats(form, stats);
    }

    function prepareMeasurementForCart(form) {
      attachPendingMeasurement(form);
      if (!form || form.querySelector('input[name="properties[' + scanActionPropertyName + ']"]')?.value) return;
      const source = form.querySelector('input[name="properties[' + scanSourcePropertyName + ']"]')?.value || '';
      const value = form.querySelector('input[name="properties[' + measuredPropertyName + ']"]')?.value ||
        form.querySelector('input[name="properties[' + measurementPropertyName + ']"]')?.value;
      // Result-button and saved-profile actions keep their own attribution.
      // A normal product-page add is labelled only when a measurement is attached.
      if (value && /^(auto_result|applied) \| /.test(source)) {
        setLineItemProperty(form, scanActionPropertyName, 'Add to Cart from product page after measurement');
      }
    }

    function savePendingMeasurement(value) {
      try {
        clearStoredMeasurement();
        sessionStorage.setItem(measurementStorageKey, value);
        sessionStorage.setItem(measurementSourceStorageKey, root.dataset.productHandle || root.dataset.productId || 'unknown-product');
        if (activeMeasurementDevice) sessionStorage.setItem(measurementDeviceStorageKey, JSON.stringify(activeMeasurementDevice));
        if (activeMeasurementStats) sessionStorage.setItem(measurementStatsStorageKey, JSON.stringify(activeMeasurementStats));
      } catch (error) {}
      attachPendingMeasurement(productForm());
    }

    function useMeasuredSizeProperty(form, action) {
      if (!form || !activeMeasurementText) return;
      clearStoredMeasurement();
      removeLineItemProperty(measurementPropertyName);
      removeLineItemProperty(scanSourcePropertyName);
      setLineItemProperty(form, measuredPropertyName, activeMeasurementText);
      setLineItemProperty(form, scanSourcePropertyName, 'applied | ' + (root.dataset.productHandle || root.dataset.productId || 'unknown-product') + ' | ' + sourceVersion);
      setLineItemProperty(form, scanActionPropertyName, action);
      removeLineItemProperty(scanDevicePropertyName);
      setLineItemProperty(form, scanDevicePropertyName, window.SpaceArmoryFitDevice?.text(activeMeasurementDevice));
      attachMeasurementStats(form, activeMeasurementStats);
    }

    function normalize(value) {
      return String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ');
    }

    function sizeAliases(size) {
      const aliases = {
        s: ['s', 'small', 'small size'],
        m: ['m', 'medium', 'medium size'],
        l: ['l', 'large', 'large size'],
        xl: ['xl', 'x-large', 'extra large', 'x large'],
        xxl: ['xxl', '2xl', 'xx-large', 'extra extra large', 'double xl']
      };
      return aliases[normalize(size)] || [normalize(size)];
    }

    function optionName(control) {
      const nameMatch = String(control.name || '').match(/^options\[(.+)\]$/i);
      if (nameMatch) return nameMatch[1];
      const fieldset = control.closest('fieldset');
      const legend = fieldset && fieldset.querySelector('legend');
      if (control.dataset.optionName) return control.dataset.optionName;
      if (legend) return legend.textContent;
      if (control.getAttribute('aria-label')) return control.getAttribute('aria-label');
      const id = control.id && document.querySelector('label[for="' + CSS.escape(control.id) + '"]');
      return id ? id.textContent : '';
    }

    function isAvailable(control) {
      if (control.disabled || control.classList.contains('disabled')) return false;
      if (control.tagName === 'SELECT') {
        const selected = Array.from(control.options).find((option) => option.value === control.value);
        return !!selected && !selected.disabled;
      }
      const labels = [];
      if (control.id) {
        const label = document.querySelector('label[for="' + CSS.escape(control.id) + '"]');
        if (label) labels.push(label);
      }
      if (control.parentElement && control.parentElement.tagName === 'LABEL') labels.push(control.parentElement);
      return !labels.some((label) => label.classList.contains('label-unavailable') || label.classList.contains('disabled'));
    }

    function findSizeControl(info, size) {
      if (!info) return null;
      const accepted = sizeAliases(size);
      const controls = Array.from(info.querySelectorAll(
        'input[type="radio"][data-option-name], input[type="radio"][name^="options"], select[data-option-name], select[name^="options"]'
      ));
      const matchesOption = (control) => /^(size|fit|beden|size fit)$/.test(normalize(optionName(control)));
      for (const control of controls) {
        if (!matchesOption(control)) continue;
        if (control.tagName === 'SELECT') {
          const option = Array.from(control.options).find((item) => accepted.includes(normalize(item.value)));
          if (option) return { control, value: option.value, available: !option.disabled, info };
        } else if (accepted.includes(normalize(control.value))) {
          return { control, value: control.value, available: isAvailable(control), info };
        }
      }
      return null;
    }

    function sizeOptionIndex() {
      try {
        const names = JSON.parse(root.dataset.productOptions || '[]');
        return names.findIndex((name) => /^(size|fit|beden|size fit)$/.test(normalize(name)));
      } catch (error) {
        return -1;
      }
    }

    function nativeEvents() {
      return {
        subscribe: typeof window.subscribe === 'function' ? window.subscribe : (typeof subscribe === 'function' ? subscribe : null),
        names: window.PUB_SUB_EVENTS || (typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null)
      };
    }

    let productVariantsCache;

    function productVariants() {
      if (productVariantsCache) return productVariantsCache;
      try {
        productVariantsCache = JSON.parse(root.querySelector('[data-face-fit-variants]')?.textContent || '[]');
      } catch (error) {
        productVariantsCache = [];
      }
      return productVariantsCache;
    }

    function selectedOptionValues(info) {
      const picker = info && info.querySelector('variant-selects');
      if (!picker) return [];
      return Array.from(picker.querySelectorAll('fieldset, .product-form__input--dropdown')).map((group) => {
        const selected = group.querySelector('input:checked') || group.querySelector('select')?.selectedOptions?.[0];
        return selected ? selected.value : '';
      });
    }

    function variantForSize(info, size) {
      const optionIndex = sizeOptionIndex();
      if (optionIndex < 0) return null;
      const selected = selectedOptionValues(info);
      const accepted = sizeAliases(size);
      return productVariants().find((variant) => Array.isArray(variant.options) && variant.options.every((value, index) => {
        if (index === optionIndex) return accepted.includes(normalize(value));
        return !!selected[index] && normalize(selected[index]) === normalize(value);
      })) || null;
    }

    function selectRecommendedSize() {
      const purchase = productInfo()?.faceFitPurchase;
      if (!purchase) throw new Error('variant_missing');
      const selected = purchase.applySize(activeSize);
      activeVariantId = String(selected.variant.id);
      return selected;
    }

    function finishScan() {
      if (finalizing || samples.length < targetSamples) return;
      finalizing = true;
      const result = classify(samples);
      const running = attemptRunning;
      const stats = result.size ? completeAttempt() : null;
      stopMedia({preserveEngine: !!result.size});
      if (!result.size) {
        attemptRunning = running;
        showError('quality');
        return;
      }
      setStage('result');
      setScreen('result', '[data-result-heading]');
      privacyAnalytics('scan_complete');
      presentMeasurement(result, null, stats);
    }

    function presentMeasurement(result, restoredRecord, scanStats) {
      activeSize = result.size;
      activeVariantId = null;
      activeMeasurementText = result.metric.toFixed(1) + ' cm / ' + (result.metric / 2.54).toFixed(2) + ' in - ' + result.size;
      // Only a fresh camera result can identify its measurement device. A restored
      // result keeps its original context, or stays unknown if it predates this field.
      activeMeasurementDevice = restoredRecord
        ? window.SpaceArmoryFitDevice?.normalize(restoredRecord.device)
        : window.SpaceArmoryFitDevice?.detect();
      activeMeasurementStats = window.SpaceArmoryFitRules?.normalizeScanStats?.(restoredRecord ? restoredRecord.scanStats : scanStats);
      savePendingMeasurement(activeMeasurementText);
      const record = restoredRecord || {schema: 1, cm: result.metric, method: 'camera', rules: sizeRuleVersion, engine: engineVersion, measuredAt: new Date().toISOString()};
      if (!restoredRecord && activeMeasurementDevice) record.device = activeMeasurementDevice;
      if (!restoredRecord && activeMeasurementStats) record.scanStats = activeMeasurementStats;
      root.dispatchEvent(new CustomEvent('space-armory:scan-complete', {bubbles: true, detail: {measurement: record, restored: !!restoredRecord}}));
      recommended.textContent = root.dataset.resultSizeTemplate.replace('__SIZE__', result.size);
      recommended.hidden = false;
      applyButton.textContent = root.dataset.resultUseTemplate.replace('__SIZE__', result.size);
      addButton.textContent = decodeText(root.dataset.resultAddTemplate.replace('__SIZE__', result.size));
      measurement.textContent = root.dataset.resultMeasurementTemplate
        .replace('__CM__', result.metric.toFixed(1))
        .replace('__INCH__', (result.metric / 2.54).toFixed(2));
      measurement.hidden = false;
      const match = findSizeControl(productInfo(), result.size);
      const canApply = !!match && !!variantForSize(productInfo(), result.size)?.available;
      manualOnly.hidden = canApply;
      manualOnly.textContent = canApply ? '' : root.dataset.resultUnavailable;
      applyButton.hidden = !canApply;
      addButton.hidden = !canApply;
      resultStatus.textContent = '';
      playResultMotion();
      triggerSuccessHaptic();
      resultHeading.focus({preventScroll: true});
    }

    listen(root, 'space-armory:clear-profile', () => {
      clearStoredMeasurement();
      activeMeasurementText = ''; activeSize = null;
      activeMeasurementDevice = null;
      activeMeasurementStats = null;
      attemptSessions.delete(attemptSessionKey);
      attemptRunning = false;
      scanAttempts = {schema:1, attempts:0, retries:0, failed:0};
      try { sessionStorage.removeItem(attemptSessionKey); } catch {}
      removeLineItemProperty(measuredPropertyName);
      removeLineItemProperty(measurementPropertyName);
      removeLineItemProperty(scanSourcePropertyName);
      removeLineItemProperty(scanActionPropertyName);
      removeLineItemProperty(scanDevicePropertyName);
      attachMeasurementStats(productForm(), null);
    });

    listen(root, 'space-armory:restore-measurement', event => {
      const record = event.detail?.measurement;
      if (!window.SpaceArmoryFitRules?.valid(record)) return;
      openDialog();
      setStage('result');
      setScreen('result', '[data-result-heading]');
      presentMeasurement({size: window.SpaceArmoryFitRules.sizeFor(record.cm), metric: record.cm}, record);
    });

    async function beginScan(options = {}) {
      if (sessionStarting) return;
      finalizing = false;
      sessionStarting = true;
      stopMedia({preserveEngine: true});
      sessionStarting = true;
      startAttempt();
      const token = generation;
      samples = [];
      lastFrameAt = 0;
      activeSize = null;
      activeVariantId = null;
      activeMeasurementText = '';
      activeMeasurementDevice = null;
      activeMeasurementStats = null;
      successHapticPlayed = false;
      resetResultMotion();
      measurement.hidden = true;
      progress.value = 0;
      setStage('camera');
      setScreen('scan', '[data-screen="scan"] .face-fit__heading');
      scanStatus.textContent = root.dataset.statusStarting;
      opener.disabled = true;
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          await showPhoneHandoff();
          return;
        }
        const preparedEngine = prepareInferenceEngine();
        preparedEngine.catch(() => {});
        const newStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 640 }, height: { ideal: 480 }, resizeMode: 'crop-and-scale' }, audio: false });
        if (token !== generation || !dialog.open) {
          newStream.getTracks().forEach((track) => track.stop());
          return;
        }
        stream = newStream;
        video.srcObject = stream;
        await video.play();
        const previewStartedAt = performance.now();
        if (!video.videoWidth) {
          await new Promise((resolve, reject) => {
            let timer;
            const finish = (error) => {
              if (timer) window.clearTimeout(timer);
              video.removeEventListener('loadedmetadata', onLoaded);
              cancelVideoMetadataWait = null;
              if (error) reject(error);
              else resolve();
            };
            const onLoaded = () => finish(null);
            timer = window.setTimeout(() => finish(new Error('video_timeout')), 8000);
            cancelVideoMetadataWait = finish;
            video.addEventListener('loadedmetadata', onLoaded, { once: true });
          });
        }
        await revealStablePreview(token, previewStartedAt);
        if (token !== generation || !dialog.open) return;
        setStage('align');
        scanStatus.textContent = root.dataset.statusPreparing;
        const currentEngine = await preparedEngine;
        if (token !== generation || !dialog.open || !currentEngine) return;
        if (inferenceMode === 'worker') worker.postMessage({type: 'reset', generation: token});
        const activeToken = generation;
        setStage('align');
        announceStatus('ready');
        launchFrameLoop(activeToken);
        sessionStarting = false;
        privacyAnalytics('stream_ready');
        stream.getVideoTracks().forEach((track) => track.addEventListener('ended', () => { if (activeToken === generation) showError('busy'); }, { once: true }));
        scanTimeout = window.setTimeout(() => {
          if (activeToken === generation && dialog.open && samples.length < targetSamples) showError('timeout');
        }, 60000);
      } catch (error) {
        if (token !== generation || !dialog.open) return;
        const name = error && error.name;
        if (options.fromHandoff && (name === 'NotAllowedError' || name === 'PermissionDeniedError')) showPhoneReady();
        else if (name === 'NotAllowedError' || name === 'PermissionDeniedError') showError('permission');
        else if (name === 'NotFoundError' || name === 'DevicesNotFoundError') await showPhoneHandoff();
        else if (name === 'NotReadableError' || name === 'TrackStartError') showError('busy');
        else showError('model');
      } finally {
        opener.disabled = false;
        if (sessionStarting && !worker && !mainThreadLandmarker && !stream) sessionStarting = false;
      }
    }

    function eventAction(event) {
      const target = event.target instanceof Element ? event.target.closest('[data-face-fit-open], [data-close], [data-start], [data-phone-start], [data-copy-handoff], [data-guide-next], [data-guide-prev], [data-guide-forward], [data-guide-skip], [data-guide-dot], [data-stop], [data-retry], [data-manual], [data-apply], [data-add]') : null;
      if (!target || !root.contains(target)) return;
      if (target.matches('[data-guide-next], [data-guide-forward], [data-guide-prev], [data-guide-dot], [data-start], [data-guide-skip]') && !acceptGuideAction()) return;
      if (target.matches('[data-face-fit-open]')) {
        if (!productInfo()?.faceFitPurchase) openDialog();
      }
      else if (target.matches('[data-close]') || target.matches('[data-stop]')) returnFocus();
      else if (target.matches('[data-guide-next], [data-guide-forward]')) setGuideStep(guideStep + 1);
      else if (target.matches('[data-guide-prev]')) setGuideStep(guideStep - 1);
      else if (target.matches('[data-guide-dot]')) setGuideStep(Number(target.dataset.guideDot));
      else if (target.matches('[data-copy-handoff]')) copyPhoneLink();
      else if (target.matches('[data-start], [data-guide-skip], [data-phone-start]') || target.matches('[data-retry]')) {
        if (target.matches('[data-retry]')) {
          manualOnly.hidden = true;
          resultStatus.textContent = '';
        }
        beginScan();
      } else if (target.matches('[data-manual]')) {
        stopMedia();
        returnFocus();
        const info = productInfo();
        const control = info && Array.from(info.querySelectorAll(
          'input[type="radio"][data-option-name], input[type="radio"][name^="options"], select[data-option-name], select[name^="options"]'
        )).find((item) => /^(size|fit|beden|size fit)$/.test(normalize(optionName(item))));
        if (control) control.focus();
      } else if (target.matches('[data-apply]')) {
        if (variantActionBusy) return;
        variantActionBusy = true;
        applyButton.disabled = true;
        addButton.disabled = true;
        resultStatus.textContent = '';
        Promise.resolve().then(() => selectRecommendedSize()).then((selected) => {
          useMeasuredSizeProperty(selected.form, 'Only Apply Size');
          resultStatus.textContent = root.dataset.resultApplied;
          privacyAnalytics('recommendation_apply');
          returnFocus();
        }).catch((error) => {
          resultStatus.textContent = error.message === 'variant_unavailable' ? root.dataset.resultUnavailable : root.dataset.resultApplyFailed;
        }).finally(() => { variantActionBusy = false; applyButton.disabled = false; addButton.disabled = false; });
      } else if (target.matches('[data-add]')) {
        addRecommendedToCart(target);
      }
    }

    async function addRecommendedToCart(button) {
      if (!activeSize || variantActionBusy) return;
      variantActionBusy = true;
      applyButton.disabled = true;
      addButton.disabled = true;
      try {
        const selected = selectRecommendedSize();
        const form = selected.form;
        if (!form || !activeVariantId) throw new Error('variant_missing');
        useMeasuredSizeProperty(form, 'Apply Size & Add to Cart');
        await productInfo().faceFitPurchase.addToCart(null, () => returnFocus({focus: false}));
        resultStatus.textContent = root.dataset.resultAdded;
        privacyAnalytics('add_to_cart_success');
      } catch (error) {
        resultStatus.textContent = error.message === 'variant_unavailable' ? root.dataset.resultUnavailable : (error.message === 'variant_missing' ? root.dataset.resultApplyFailed : error.message || root.dataset.resultAddFailed);
        privacyAnalytics('add_to_cart_fail');
      } finally {
        variantActionBusy = false;
        applyButton.disabled = false;
        addButton.disabled = false;
      }
    }

    function preventMotionMenu(event) {
      if (event.target instanceof Element && event.target.closest('[data-motion-art]')) event.preventDefault();
    }

    listen(root, 'contextmenu', preventMotionMenu, true);
    listen(root, 'dragstart', preventMotionMenu, true);
    listen(root, 'click', eventAction);
    listen(root, 'space-armory:open-scanner', openDialog);
    listen(root, 'space-armory:prepare-cart', () => prepareMeasurementForCart(productForm()));
    guideVideos.forEach((item, index) => {
      listen(item, 'playing', () => prepareNextGuideVideo(index));
    });
    if (guide) {
      listen(guide, 'pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0 || root.dataset.activeScreen !== 'intro') return;
        if (event.target instanceof Element && event.target.closest('button')) return;
        guidePointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        try { guide.setPointerCapture(event.pointerId); } catch (error) {}
      });
      listen(guide, 'pointerup', (event) => {
        const start = guidePointer;
        guidePointer = null;
        if (!start || start.id !== event.pointerId || root.dataset.activeScreen !== 'intro') return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
        setGuideStep(guideStep + (dx < 0 ? 1 : -1));
      });
      listen(guide, 'pointercancel', () => { guidePointer = null; });
      listen(guide, 'lostpointercapture', () => { guidePointer = null; });
      listen(guide, 'keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        setGuideStep(guideStep + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }
    listen(document, 'click', (event) => {
      const target = event.target instanceof Element ? event.target.closest('button[name="add"], button[type="submit"], input[type="submit"]') : null;
      const form = target && target.form;
      if (form && form === productForm()) prepareMeasurementForCart(form);
    }, true);
    listen(document, 'submit', (event) => {
      if (event.target === productForm()) prepareMeasurementForCart(event.target);
    }, true);
    attachPendingMeasurement(productForm());
    listen(dialog, 'cancel', () => stopMedia());
    listen(dialog, 'close', finishDialogClose);
    listen(video, 'ended', () => showError('busy'));
    listen(window, 'pagehide', stopMedia);
    listen(document, 'visibilitychange', () => { if (document.visibilityState === 'hidden' && stream) showError('background'); });
    if (window.location.hash === '#face-fit-start') {
      // Consume once so refresh/back does not unexpectedly reopen the camera.
      history.replaceState(history.state, '', window.location.pathname + window.location.search);
      openDialog();
      beginScan({ fromHandoff: true });
    }
    root.disposeScanner = () => {
      lifecycle.abort();
      stopMedia();
      focusAfterClose = false;
      if (dialog.open) dialog.close();
      finishDialogClose();
      delete root.dataset.initialized;
    };
    root.dispatchEvent(new CustomEvent('space-armory:scanner-ready'));
    }
    const activeScanners = new Set();
    function mountScanners() {
      activeScanners.forEach(root => { if (!root.isConnected) { root.disposeScanner?.(); activeScanners.delete(root); } });
      document.querySelectorAll('face-fit-scanner').forEach(root => {
        if (!activeScanners.has(root)) { delete root.dataset.initialized; initializeScanner(root); }
        activeScanners.add(root);
      });
    }
    mountScanners();
    document.addEventListener('shopify:section:load', mountScanners);
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('face-fit-scanner') || node.querySelector('face-fit-scanner'))))) mountScanners();
    }).observe(document.documentElement, {childList: true, subtree: true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["manual-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('manual-size-guide')) {
    customElements.define('manual-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle) return;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-manual-guide-open]');
        if (!this.dialog || !this.opener) return;
        this.lifecycle = new AbortController();
        const options = {signal: this.lifecycle.signal};
        const protectImage = event => {
          if (event.target instanceof Element && event.target.closest('.manual-size-guide__image')) event.preventDefault();
        };
        this.addEventListener('contextmenu', protectImage, options);
        this.addEventListener('dragstart', protectImage, options);
        this.opener.addEventListener('click', () => this.open(this.opener), options);
        this.querySelector('[data-manual-guide-close]').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        this.querySelectorAll('[data-unit]').forEach(tab => {
          tab.addEventListener('click', () => this.selectUnit(tab.dataset.unit), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const unit = event.key === 'Home' ? 'in' : event.key === 'End' ? 'cm' : tab.dataset.unit === 'in' ? 'cm' : 'in';
            this.selectUnit(unit);
            this.querySelector(`[data-unit="${unit}"]`).focus();
          }, options);
        });
      }

      selectUnit(unit) {
        if (unit !== 'in' && unit !== 'cm') return;
        this.querySelectorAll('[data-unit]').forEach(tab => {
          const selected = tab.dataset.unit === unit;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected) this.querySelector('[data-unit-panel]').setAttribute('aria-labelledby', tab.id);
        });
        this.querySelectorAll('[data-in][data-cm]').forEach(cell => { cell.textContent = cell.dataset[unit]; });
        const label = unit === 'in' ? 'inches' : 'centimeters';
        this.querySelector('table').setAttribute('aria-label', `Mask size chart in ${label}`);
        this.querySelector('[data-unit-heading]').textContent = `Measurement in ${label}`;
      }

      open(trigger = this.opener) {
        if (this.dialog.open || this.closest('product-info')?.querySelector('face-fit-scanner dialog[open]')) return;
        this.returnFocus = trigger;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.scrollLocked = true;
        this.dialog.showModal();
        this.dispatchEvent(new CustomEvent('space-armory:sizing-guide-opened', {bubbles: true, detail: {guide: 'manual'}}));
        this.querySelector('.manual-size-guide__content').scrollTop = 0;
        this.querySelector('[data-manual-guide-close]').focus({preventScroll: true});
        this.notifyVisibility();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
        this.afterClose();
      }

      afterClose() {
        if (!this.scrollLocked || this.dialog.open) return;
        document.body.style.overflow = this.previousOverflow;
        this.scrollLocked = false;
        this.notifyVisibility();
        if (this.isConnected && this.returnFocus?.isConnected && !this.returnFocus.hidden) this.returnFocus.focus({preventScroll: true});
      }

      notifyVisibility() {
        this.dispatchEvent(new CustomEvent('space-armory:scanner-visibility', {bubbles: true}));
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.lifecycle = null;
        if (this.dialog?.open) this.dialog.close();
        this.afterClose();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
